import { useAuthStore } from '@/features/auth/useAuthStore.js'
import {
  getInvitationCodeFromQuery,
  pickInvitationQueryForRoute,
} from '@/features/auth/utils/authInvitationQuery.js'
import { CLUB_SELECTOR_PATH } from '@/features/auth/clubSelfRegistrationConfig.js'
import { getActiveClubId } from '@/features/router/useActiveClub.js'

export function authEntryGuard(to, from, next) {
  const authStore = useAuthStore()

  if (!authStore.isLoggedIn) {
    next()
    return
  }

  const invitationCode = getInvitationCodeFromQuery(to.query)

  if (invitationCode) {
    next({
      path: CLUB_SELECTOR_PATH,
      query: pickInvitationQueryForRoute(to.query),
    })
    return
  }

  const clubId = getActiveClubId()

  if (!clubId) {
    next(CLUB_SELECTOR_PATH)
    return
  }

  next()
}
